import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ot',
  templateUrl: './ot.component.html',
  styleUrls: ['./ot.component.scss'],
})
export class OT implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
